import { render, staticRenderFns } from "./updateDeliveryInfoVue.vue?vue&type=template&id=36a52d35&scoped=true"
import script from "./updateDeliveryInfoVue.vue?vue&type=script&lang=js"
export * from "./updateDeliveryInfoVue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a52d35",
  null
  
)

export default component.exports